import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, Hidden /* , IconButton */ } from '@material-ui/core'
import Snippets from './Snippets/Snippets'
import Variables from './Variables/Variables'
import General from './General/General'
import TemplateHtml from './TemplateHtml'
import RSC from 'react-scrollbars-custom'
import { last } from 'lodash'
import SMS from 'components/AddOrEditTaskPage/Preview/SMS'
import { toggleDefaultValuesModal } from 'actions/template'
// import { CodeBraces } from 'mdi-material-ui'

export default connect(
  state => ({
    bottomNavigation: state.email.bottomNavigation,
    // sectionSelectedBoolean: typeof state.email.sectionSelected === 'number',
    emailCardSelected: last(state.email.cardSelected),
  }),
  dispatch => bindActionCreators({ toggleDefaultValuesModal }, dispatch),
  null,
)(
  ({
    // sectionSelectedBoolean,
    bottomNavigation,
    emailCardSelected,
    toggleDefaultValuesModal,
  }) => {
    const bottomNav = () => {
      switch (bottomNavigation) {
        case 0:
          return null
        case 1:
          return <Variables />
        case 2:
          return <General emailCardSelected={emailCardSelected} mobile />
        case 3:
          return <Snippets mobile />
        default:
          return null
      }
    }

    return (
      <Hidden mdUp>
        <Grid
          style={{
            backgroundColor: '#fff',
            height: '100%',
            paddingTop: 55,
            width: '100%',
            margin: 0,
          }}
          container
          spacing={24}
        >
          <Grid
            style={{ height: 'calc(100% + 52px)', padding: 0 }}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <RSC style={{ height: '100%' }} noScrollX>
              <div
                style={
                  bottomNavigation === 0
                    ? { display: 'relative' }
                    : { display: 'none' }
                }
              >
                {emailCardSelected === 'sms' ? (
                  <>
                    <SMS />
                    {/* <div
                      style={{ position: 'absolute', bottom: 90, right: 21 }}
                    >
                      <IconButton
                        onClick={() => toggleDefaultValuesModal(true)}
                        style={{ color: '#014c94' }}
                      >
                        <CodeBraces />
                      </IconButton>
                    </div> */}
                  </>
                ) : (
                  <TemplateHtml />
                )}
              </div>
              {bottomNav()}
            </RSC>
          </Grid>
        </Grid>
      </Hidden>
    )
  },
)
